import React from 'react';
import { Grid } from '@material-ui/core';

import useAuthentication from 'domain/authentication/useAuthentication';

import AuthenticationButtons from './buttons/authentication/AuthenticationButtons';
import Description from './typography/Description';

const Protected = ({ children, justify = 'center' }) => {
  const { isAuthenticated } = useAuthentication();

  return isAuthenticated ? (
    children
  ) : (
    <Grid container direction="column">
      <Grid item container justify={justify}>
        <Description>
          You are <b>not</b> authenticated
        </Description>
      </Grid>

      <Grid item container justify={justify} style={{ marginTop: 8 }}>
        <AuthenticationButtons justify={justify}></AuthenticationButtons>
      </Grid>
    </Grid>
  );
};

export default Protected;
